import { useState, useEffect } from 'react';
import { useIsMobile } from './use-mobile';

export const useZoomControls = (initialZoom = 1.0) => {
  const isMobile = useIsMobile();
  const [zoomLevel, setZoomLevel] = useState(isMobile ? 1.0 : initialZoom);

  // Update zoom level when device type changes
  useEffect(() => {
    if (isMobile) {
      setZoomLevel(1.0); // Fixed 100% scale for mobile
    }
  }, [isMobile]);

  const handleZoomIn = () => {
    if (!isMobile) {
      setZoomLevel(prev => Math.min(prev + 0.1, 2));
    }
  };

  const handleZoomOut = () => {
    if (!isMobile) {
      setZoomLevel(prev => Math.max(prev - 0.1, 0.5));
    }
  };

  const handleReset = () => {
    if (!isMobile) {
      setZoomLevel(1.0);
    }
  };

  return {
    zoomLevel,
    setZoomLevel,
    handleZoomIn,
    handleZoomOut,
    handleReset,
    isMobile,
  };
};
